export enum VisitsStatusEnum {
ON_GOING = 'ON_GOING',
UPCOMING = 'UPCOMING',
NO_SHOW = 'NO_SHOW',
CHECKED_OUT = 'CHECKED_OUT'
}
